import { CardBlockImage } from "entities/modules/types";
import { Timestamp, addDoc, collection } from "firebase/firestore";
import { db } from "shared/api/firebase";
import { PageModuleDataToCreate } from "../types";
import { savePageContentBlocksModuleImage } from "./savePageContentBlocksModuleImage";
import { savePageTopPrivacyTipsBlockModuleImage } from "./savePageTopPrivacyTipsBlockModuleImage";

type Params = {
  moduleData: PageModuleDataToCreate;
  brandId: string;
  pageId: string;
  cardBlockImages: CardBlockImage[];
  topPrivacyTipsBlockImage: CardBlockImage;
};

export const createPageModule = async ({
  moduleData,
  brandId,
  pageId,
  cardBlockImages,
  topPrivacyTipsBlockImage,
}: Params): Promise<void> => {
  const collectionRef = collection(
    db,
    `brands/${brandId}/pages/${pageId}/modules`,
  );
  const createdModuleDoc = await addDoc(collectionRef, {
    ...moduleData,
    createdAt: Timestamp.now(),
    updatedAt: Timestamp.now(),
  });

  if (cardBlockImages.some((item) => item instanceof File)) {
    await savePageContentBlocksModuleImage({
      brandId,
      moduleId: createdModuleDoc.id,
      pageId,
      cardBlockImages,
    });
  }

  if (topPrivacyTipsBlockImage instanceof File) {
    await savePageTopPrivacyTipsBlockModuleImage({
      brandId,
      moduleId: createdModuleDoc.id,
      pageId,
      topPrivacyTipsBlockImage,
    });
  }
};
